import { IDealership } from "src/types/Dealership";

interface FetchDealershipSelectorParams {
  postalCode: string;
  streetNumber: string;
  type?: string;
  fetchData: (params: {
    endpoint: string;
    queryParameters: Record<string, any>;
  }) => Promise<{ data: IDealership[] }>;
}

export const fetchDealershipSelector = async ({
  postalCode,
  streetNumber,
  type,
  fetchData,
}: FetchDealershipSelectorParams): Promise<IDealership[]> => {
  try {
    const response = await fetchData({
      endpoint: "companies/selector",
      queryParameters: {
        country: "NL",
        postalCode,
        streetNumber,
        type: type ?? "dealership",
      },
    });

    if (response && response.data) {
      response.data.forEach((dealership: IDealership) => {
        dealership.dealershipIri = dealership.companyIri;
      });
      return response.data;
    } else {
      throw new Error("Geen dealer bedrijven gevonden");
    }
  } catch (err: unknown) {
    console.error("Error fetching dealer bedrijven:", err);
    throw new Error("Error dealer bedrijven gevonden");
  }
};
